<template>
    <div
        v-if="isImpersonating"
        class="impersonation-banner tw:flex tw:items-center tw:justify-center tw:gap-3 tw:bg-amber-500 tw:text-white tw:py-2 tw:px-4 tw:text-sm tw:font-medium"
    >
        <i class="uil uil-exclamation-triangle" />
        <span>You are impersonating <strong>{{ impersonatorTargetName }}</strong></span>
        <button
            class="tw:ml-2 tw:bg-white tw:text-amber-700 tw:px-3 tw:py-1 tw:rounded tw:text-xs tw:font-semibold tw:hover:bg-amber-100 tw:transition-colors"
            :disabled="isStoppingImpersonation"
            :class="{ 'tw:cursor-not-allowed tw:opacity-60': isStoppingImpersonation }"
            @click="stopImpersonation"
        >
            {{ isStoppingImpersonation ? 'Stopping...' : 'Stop Impersonation' }}
        </button>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
    name: 'ImpersonationBanner',

    computed: {
        ...mapGetters('Impersonation', ['isImpersonating', 'impersonator', 'isStoppingImpersonation']),

        impersonatorTargetName() {
            const { user } = this.$store.state.Auth;
            return user ? `${user.first_name} ${user.last_name}` : 'another user';
        },
    },

    methods: {
        ...mapActions('Impersonation', ['stopImpersonation']),
    },
};
</script>

<style lang="scss">
$banner-height: 2.25rem;

.impersonation-banner {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: $banner-height;
    z-index: 1001;
}

.is-impersonating {
    .layout-topbar {
        top: $banner-height;
    }

    .layout-content-wrapper {
        padding-top: calc(5rem + #{$banner-height});
    }

    .layout-content {
        height: calc(100vh - 5rem - #{$banner-height});
    }

    .layout-sidebar {
        top: calc(5rem + #{$banner-height});
    }
}
</style>
